import Image from 'next/image';
import ConfusedHippoSrc from '@/assets/confused-hippo.png';

interface PhonicsLogoProps {
  className?: string;
}

export const ErrorHippo = ({ className }: PhonicsLogoProps) => (
  <Image
    src={ConfusedHippoSrc}
    alt="A hippo shrugguing its shoulders, looking confused."
    className={className}
  />
);
